import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

export default function PostTransferTranscriptionInfo() {
  return (
    <div className="flex gap-x-2 items-center">
      <ExclamationCircleIcon className="text-blue-500 size-4" />
      <p className="font-xs text-xs text-blue-500">
        Transcription duration will be added to the total call duration
      </p>
    </div>
  );
}
